import React, {useEffect, useState} from "react";
import Sidebar from "./Sidebar";
import {Link} from "react-router-dom";
import {orderApi} from "../../api";
import AdminSpinner from "../components/AdminSpinner"; // doğru path'e göre düzelt

export default function Orders({setSelectedOrder, setOrderLoading, onLoaded}) {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);


    useEffect(() => {
        const fetchOrders = async () => {
            setLoading(true);
            try {
                const res = await orderApi.getPaginatedOrders(currentPage, 5); // 5 = limit
                setOrders(res.data.orders);
                setTotalPages(res.data.pagination.totalPages);
                onLoaded?.();
            } catch (err) {
            } finally {
                setLoading(false);
            }
        };

        fetchOrders();
    }, [currentPage]);

    const cancelOrderRequest = async (orderGuid) => {
        try {
            setLoading(true);
            const res = await orderApi.cancelOrder(orderGuid);

            // Siparişleri yeniden çek
            const refreshed = await orderApi.getPaginatedOrders(currentPage, 5);
            setOrders(refreshed.data.orders);
            setTotalPages(refreshed.data.pagination.totalPages);
        } catch (err) {
        } finally {
            setLoading(false);
        }
    };

    const requestRefund = async (orderGuid) => {

        try {
            await orderApi.requestRefund(orderGuid); // Backend'e gönder

            const modalEl = document.getElementById("refund_request");
            if (modalEl && window.bootstrap?.Modal) {
                const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
                modal.show();
            }

            // ✅ Sipariş listesini arkada güncelle
            const res = await orderApi.getPaginatedOrders(currentPage, 5);
            setOrders(res.data.orders);
            setTotalPages(res.data.pagination.totalPages);
        } catch (err) {

        }
    };


    return (
        <div className="main-content-account">
            {/* ... breadcrumb + title + sidebar kodları ... */}

            <section className="s-account flat-spacing-17">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="my-account-container">
                                <div className="sidebar-account-wrap sidebar-content-wrap sticky-top d-lg-block d-none">
                                    <ul className="my-account-nav">
                                        <Sidebar/>
                                    </ul>
                                </div>
                                <div className="my-acount-content account-orders">
                                    {loading ? (
                                        <div className="local-spinner-container">
                                            <span className="loader"></span>
                                        </div>
                                    ) : orders.length === 0 ? (
                                        <div className="account-no-orders-wrap">
                                            <img src="/images/section/account-no-order.png" alt="No orders"/>
                                            <div className="display-sm fw-medium title">
                                                You haven’t placed any order yet
                                            </div>
                                            <div className="text text-sm">
                                                It’s time to make your first order
                                            </div>
                                            <Link
                                                to={`/shop-fullwidth`}
                                                className="tf-btn animate-btn d-inline-flex bg-dark-2 justify-content-center"
                                            >
                                                Shop Now
                                            </Link>
                                        </div>
                                    ) : (
                                        <div className="account-orders-wrap">
                                            <h5 className="title">Order History</h5>
                                            <div className="wrap-account-order">
                                                <table>
                                                    <thead>
                                                    <tr>
                                                        <th>Order ID</th>
                                                        <th>Date</th>
                                                        <th>Status</th>
                                                        <th>Total</th>
                                                        <th>Action</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {orders.map(order => (
                                                        <tr key={order.orderNumber} className="tf-order-item">
                                                            <td>{order.orderNumber}</td>
                                                            <td>
                                                                {new Date(order.orderDate).toLocaleDateString('en-GB', {
                                                                    day: '2-digit', month: 'short', year: 'numeric'
                                                                })}
                                                            </td>
                                                            <td className={`text-md ${
                                                                ["cancelled", "rejected"].includes(order.status?.toLowerCase()) ? "text-danger" :
                                                                    ["cancelrequested", "refundrequested"].includes(order.status?.toLowerCase()) ? "text-warning" :
                                                                        `text-${order.status?.toLowerCase()}`
                                                            }`}>
                                                                {order.status === "CancelRequested" ? "Cancel Requested"
                                                                    : order.status === "RefundRequested" ? "Refund Requested"
                                                                        : order.status}
                                                            </td>
                                                            <td>
                                                                £{order.totalPrice?.toFixed(2)} / {order.totalItems} item{order.totalItems > 1 ? "s" : ""}
                                                            </td>
                                                            <td className="d-flex gap-2">
                                                                {/* actions */}
                                                                <a
                                                                    href="#"
                                                                    className="view-detail"
                                                                    onClick={async (e) => {
                                                                        e.preventDefault();
                                                                        setOrderLoading(true);
                                                                        const modalEl = document.getElementById("order_detail");
                                                                        if (modalEl && window.bootstrap?.Modal) {
                                                                            window.bootstrap.Modal.getOrCreateInstance(modalEl).show();
                                                                        }
                                                                        try {
                                                                            const res = await orderApi.getOrderByGuid(order.orderGuid /* ya da order.guid */);
                                                                            setSelectedOrder(res.data.order);
                                                                        } finally {
                                                                            setOrderLoading(false);
                                                                        }
                                                                    }}
                                                                >
                                                                    Detail
                                                                </a>

                                                                {["waiting", "processing"].includes(order.status?.toLowerCase()) && (
                                                                    <button className="view-detail"
                                                                            onClick={() => cancelOrderRequest(order.orderGuid)}>
                                                                        Cancel
                                                                    </button>
                                                                )}

                                                                {order.isRefundAvailable && (
                                                                    <button className="view-detail"
                                                                            onClick={() => requestRefund(order.orderGuid)}>
                                                                        Refund
                                                                    </button>
                                                                )}
                                                            </td>
                                                        </tr>

                                                    ))}
                                                    </tbody>
                                                </table>
                                                {/* Pagination */}
                                                <div
                                                    className={`wrapper-shop tf-grid-layout tf-col-`}
                                                    id="gridLayout"
                                                >
                                                    <ul className="wg-pagination justify-content-center mt-4">
                                                        {/* Geri butonu */}
                                                        {currentPage > 1 && (
                                                            <li>
                                                                <button
                                                                    className="pagination-item"
                                                                    onClick={() => setCurrentPage(currentPage - 1)}
                                                                >
                                                                    <i className="icon-arr-left"/>
                                                                </button>
                                                            </li>
                                                        )}

                                                        {/* Sayfa numaraları */}
                                                        {Array.from({length: totalPages}, (_, i) => (
                                                            <li key={i}
                                                                className={currentPage === i + 1 ? "active" : ""}>
                                                                <button
                                                                    className="pagination-item"
                                                                    onClick={() => setCurrentPage(i + 1)}
                                                                >
                                                                    {i + 1}
                                                                </button>
                                                            </li>
                                                        ))}

                                                        {/* İleri butonu */}
                                                        {currentPage < totalPages && (
                                                            <li>
                                                                <button
                                                                    className="pagination-item"
                                                                    onClick={() => setCurrentPage(currentPage + 1)}
                                                                >
                                                                    <i className="icon-arr-right2"/>
                                                                </button>
                                                            </li>
                                                        )}
                                                    </ul>
                                                </div>

                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}
